"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = newValidator;
exports.updateValidator = updateValidator;

function newValidator(data) {
  if (!data) {
    data = {};
  }

  return {
    data: data,
    isValid: true,
    messages: []
  };
}

function updateValidator(v, messages) {
  v.messages = v.messages.concat(messages);
  var valid = messages.length == 0;
  v.isValid = v.isValid && valid;
  return v;
}